import React from 'react';
import { useDarkMode } from '../contexts/DarkModeContext';
import { Product } from '../data/interfaces/Product';
import { Variation } from '../data/interfaces/Variation';
import { getGameColor } from '../data/objects/gameColor';
import { Link } from 'react-router-dom';

interface RequiredModCardProps {
    product: Product;
    variation: Variation;
}

const RequiredModCard: React.FC<RequiredModCardProps> = ({ product, variation }) => {
    const { isDarkMode } = useDarkMode();
    const gameColor = getGameColor(product.game);

    return (
        <>
            <Link to={`/works/${product.slug}/${variation.variationId}`} className="card-link" style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className={`card row release-info-container ${isDarkMode ? 'dark-mode-3' : 'light-mode-3'}`}>

                    <p className="card-text">This add-on requires a base mod in order to use:</p>
                    <div className="col-lg-7 mb-2 main-preview">
                        <img
                            src={product.thumbnailUrl}
                            className="img-fluid rounded"
                            alt={product.title}
                        />
                    </div>
                    <div className="col-lg-5">
                        <h5 className="card-title">{product.title} (Style {variation.variationId})</h5>

                        <div className="d-flex align-items-center">
                            <div
                                className="game-indicator"
                                style={{
                                    backgroundColor: gameColor
                                }}
                            ></div>
                            <p className="card-text m-0">{product.game}</p>
                        </div>
                    </div>
                </div>
            </Link>
        </>
    );
};

export default RequiredModCard;

